<template>
    <v-main>
        <v-container fluid fill-height class="pa-0 mb-14 mb-sm-0">
            <transition name="slide" mode="out-in">
                <router-view/>
            </transition>
        </v-container>
        <v-btn bottom left fab fixed elevation="4" color="primary" class="hidden-xs-only" to="/calculator/public">
            <v-icon large>mdi-calculator-variant</v-icon>
        </v-btn>
        <v-bottom-navigation grow fixed dark background-color="primary" color="accent" class="hidden-sm-and-up">
            <v-btn class="px-1" to="/login">
                <span>Iniciar Sesión</span>
                <v-icon>mdi-account-key</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/register">
                <span>Crear Cuenta</span>
                <v-icon>mdi-account-plus</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/calculator/public">
                <span>Cotizador</span>
                <v-icon>mdi-calculator-variant</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-main>
</template>

<script>
export default {}
</script>
